import React from 'react';
import { Avatar, Grid } from '@mui/material';
import { observer } from 'mobx-react';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';

type Props = {
  focus?: boolean
};

const LoggedOffButton: React.FC<Props> = observer(() => (
  <div style={{ position: 'relative', width: '100%', height: '100%' }}>
    <Grid container sx={{ height: '100%' }}>
      <Avatar
        src={ThemeStore.theme.character?.lockedIcon ?? undefined}
        sx={{ width: '100%', height: '100%' }}
      />
    </Grid>
  </div>
));

export default LoggedOffButton;
